




























import { Component, Vue } from 'vue-property-decorator'
import PhotoHeader from '@/components/organization/PhotoHeader.vue'
import Main from '@/components/organization/Main.vue'
import Paragraph from '@/components/organization/Paragraph.vue'
import HorizontalList from '@/components/organization/HorizontalList.vue'
import Speakers from '@/components/organization/Speakers.vue'
import Columns from '@/components/organization/Columns.vue'
import Organization from '@/components/organization/Names.vue'
//import Supporters from '@/components/organization/Supporters.vue'
//import { speakers_list } from '@/storage/programacao/speakers'

@Component({
  components: {
    PhotoHeader,
    Main,
    HorizontalList,
    Paragraph,
    Speakers,
    Columns,
    Organization
    //Supporters
  }
})
export default class Escola extends Vue {
  private speakers: any = null
  private photos: any

  constructor() {
    super()

    this.photos = [
      '/assets/img/egressos/10.jpeg',
      '/assets/img/egressos/11.jpeg',
      '/assets/img/egressos/12.jpeg',
      '/assets/img/egressos/13.jpeg',
      '/assets/img/egressos/14.jpeg',
      '/assets/img/egressos/15.jpeg',
      '/assets/img/egressos/16.jpeg',
      '/assets/img/egressos/8.jpeg',
      '/assets/img/egressos/1.jpeg',
      '/assets/img/egressos/2.jpeg',
      '/assets/img/egressos/3.jpeg',
      '/assets/img/egressos/4.jpeg',
      '/assets/img/egressos/5.jpeg',
      '/assets/img/egressos/6.jpeg',
      '/assets/img/egressos/7.jpeg'
    ]
  }
}
